import Firebase from 'firebase/firebase'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'

let config = {
	apiKey: process.env.API_KEY,
	authDomain: process.env.AUTH_DOMAIN,
	databaseURL: process.env.DATABASE_URL,
	projectId: process.env.PROJECT_ID,
	storageBucket: process.env.STORAGE_BUCKET,
	messagingSenderId: process.env.MESSAGING_SENDER_ID,
	appId: process.env.APP_ID,
	measurementId: process.env.MEASUREMENT_ID
}

const app = Firebase.initializeApp(config)

export const db = app.database()


// WEBPACK FOOTER //
// ./src/firebase.js